/**
 * 索赔详情 2.0
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/31      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import Lang from "@components/Lang/Lang"
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {Popconfirm, Alert, Spin,message} from 'antd';
import {symbolMoneyUtil,toFixed2,isEmpty,isEmptyObject,getFileSuffix} from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import { renderFileType } from "@components/UploadFile/UploadImage/file.util";
import {StatusLabel, TypeLabel,} from "./components/label";
import DetailHandleForm from "./components/detailHandleForm";
import dayjs from "dayjs";
import ClaimSkuWrap from "../../../components/claimSkuWrap/SkuWrap";
import History from "../ClaimDemageInfo/components/History"
import AfterSaleService from "../AfterSale.action";
import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";
import "./detail.less";

export default class AfterSaleInitiatedByCustomer extends React.Component{
    constructor(props) {
        super(props);
        this.__getServerLanguage = __getServerLanguage;
        //获取头部数据
        this.state = {
            loading: false, //数据加载等待
            model:{},
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 获取 商品列表 标题
     * @return {string}
     * 索赔类型：damaged：破损，disable：买贵，arrive_late：晚到
     * 申请时状态status 1：审核中（待处理），2：待赔付，3：已拒绝，4：撤销申请，5：已赔付 7:待客户处理
     */
    getSkuType(type="",status=""){
        if(type=="damaged"){
            // if(status=="1") return""; 工作台统一显示破损
            return Lang({id:"ShangPinYiPoSun", default:"商品已破损"});
        }else if(type=="disable"){
            return Lang({id:"ShangPinMaiGuiLiao", default:"商品买贵了"});
        }else return"";
    }
    /*
    * 渲染详情子项
    * */
    renderDesc(title="",desc="",threeRow){
        return (<div className={"mt_16"}>
            <div className={"black89 font_16 fw_700 lineH_24"}>{title}</div>
            {desc&&<div className={"black66 font_14"}>{desc}</div>}
            {threeRow&&<div className={"black66 font_14"}>{threeRow}</div>}
            </div>)
    }
    /*
    * 渲染详情子项 有底部的线
    * */
    renderDescLine(title="",desc="",){
        return (<div className={"lineRow flex-item-between"}>
            <div className={"black89"}>{title}</div>
           <div className={"black66 "}>{desc}</div>
        </div>)
    }
    /*
    * 获取赔偿方式
    * */
    getClaimType(type,list=[]){
        if(type&&list.length>0){
           const item = list.find(item=>item.code==type);
           if(item){
               return item.name
           }else return ""
        }
        return ""
    }
    /*
    * 撤消操作
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7948
    * */
    handleCancel(){
        if(this.props.handleCancel){
            this.props.handleCancel();
        }
    }
    /*
   * 付款登录操作
   * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7948
   * */
    handlePay(){
        const {claimDemageOrderId,model } = this.props;
        if(claimDemageOrderId){
            const data ={
                id:claimDemageOrderId,
                serviceTypeCode: model.type
            }
            const sUrl =  "/service/mg/sale/claimDemage/refund/dispose";
            this.loading(true)
            AfterSaleService.postHttpAction(sUrl,data,).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
        }
    }

    handleSaveRes(resData={},){
        // 响应结果
        this.loading(false)
        const { success,valid,model={}} = resData;
        if(success&valid){
            message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
            // 刷新页面
            if(this.props.successBack)this.props.successBack();
        }else if(resData.message){
            message.error(resData.message);
        }else message.error(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
    }
    componentWillMount() {
    }
    componentDidMount(){

    }
    render(){
        const { model,claimDemageOrderId } = this.props;
        const { loading,values } = this.state;
        const mgPoInfoVO = model.mgPoInfoVO ||{};
        // 单位
        const sUnit = mgPoInfoVO.skuCount>1?"PCS":__getServerDictItem("unit_type." + mgPoInfoVO.skuUnit);
        const showDaDi = model.type=="damaged"||model.type=="disable"; // 特定 破损 和买贵 才显示的部分

        const currPageName = Lang({id: "ShouHouXiangQing",default: "售后详情"});
        return (<Spin spinning={loading}>
                <PageCommon>
            <CommonBreadcrumb list={[
                { name:Lang({id: "KeHuFaQiLieBiao",default: "客户发起列表"}),link:'/afterSale/customerInitiated'},
                { name:currPageName}]}></CommonBreadcrumb>
                <div className={"afterSaleWrap black89 font_14"}>
                        <div className={"main"}>
                            <div className={"flex-item-between"}>
                                <div>
                                    <div className={"black89 font_18 fw_700"}>
                                        {Lang({id:'ShouHou',default:"售后"})}<span className={"ml_6"}>{model.demageCode}</span>
                                    </div>
                                    <div className={"mt_4 flex-item-ver-center fw_700 font_18"}>
                                        {/* 工作台状态：statusMg 1:待处理 2:审核通过 3:已驳回 4:已撤销 5:已赔付 6:已失效 7:待汇款 8:已关闭 9:已发起 */}
                                        <StatusLabel statusCode={model.statusMg} status={model.statusMgName} />
                                        <TypeLabel typeCode={model.type} type={model.typeName} className={"ml_8"} />
                                    </div>
                                </div>
                                {/* 破损 | 买贵 撤销申请 canClose 0:不显示, 1:显示*/}
                                {showDaDi&&model.canClose=="1"&&<Popconfirm overlayClassName={"poAfterDetailPopconfirm"}
                                    title={<div className={"black89 font_14"}>
                                        <div className={"font_18 fw_700"}>{Lang({id:"TiShi",default:"提示"})}</div>
                                        {Lang({id:"ShiFouYaoGuanBiSuoPeiShenQing",default:"是否要关闭赔偿申请"})}
                                    </div>}
                                    icon={null}
                                    onConfirm={()=>this.handleCancel()}
                                    okText={__getServerLanguage('QueDing')}
                                    cancelText={__getServerLanguage('QuXiao')}>
                                    <div className={"btnCancel"}>
                                        {Lang({id:"GuanBiPeiChang",default:"关闭赔偿"})}
                                    </div>
                                </Popconfirm>}
                                {/* 7:待汇款  适应所有类型   */}
                                {/*{model.statusMg=="7"&&<Popconfirm overlayClassName={"poAfterDetailPopconfirm"}*/}
                                                                  {/*title={<div className={"black89 font_14"}>*/}
                                                                                {/*<div className={"font_18 fw_700"}>{Lang({id:"TiShi",default:"提示"})}</div>*/}
                                                                                {/*{Lang({id:"QueRenYiJingHuiKuanGeiKeHuJiangSuoPeiDanBiaoShiWeiYiHuiKuan",default:"确认已经汇款给客户，将索赔单标识为已汇款？"})}*/}
                                                                            {/*</div>}*/}
                                                                  {/*icon={null}*/}
                                                                  {/*onConfirm={()=>this.handlePay()}*/}
                                                                  {/*okText={Lang({id:'QueDing',default: "确定"})}*/}
                                                                  {/*cancelText={Lang({id:'QuXiao',default: "取消"})} >*/}
                                    {/*<div className={"btnPay"}>*/}
                                        {/*{Lang({id:"HuiKuan",default:"汇款"})}*/}
                                    {/*</div>*/}
                                {/*</Popconfirm>}*/}
                            </div>
                            {/* 时间 */}
                           {showDaDi&&<div className={"mt_4 mb_16 black45"}>
                                {model.demageCreateTime?dayjs(model.demageCreateTime).format('YYYY-MM-DD HH:mm:ss'):"-"}
                            </div>}
                            {/* 破损 买贵 的  处理中 提示 */}
                            {showDaDi&&model.statusMg=="1"&&model.waitDays&&model.waitDays>0?<Alert message={Lang({id:"JuLiShangCiChuLiYiDengDaiNTian",default:`距离上次处理，已等待 ${model.waitDays} 天`,params:[model.waitDays]})}
                                                                 type="warning" showIcon />:null}
                            {/*  买贵|晚到 才显示 客户信息 */}
                            {(model.type=="disable"||model.type=="arrive_late")&&<div className={"mt_16 clientInfo"}>
                                <div className={'black89 font_16 fw_700'}>
                                    {Lang({id:'KeHuXinXi',default:"客户信息"})}
                                </div>
                                <div className={"mt_4"}>
                                    <a className={"color-blue"} target={"_blank"} href={"/customer/detail?id="+model.buyerId}>{model.buyerCode}</a>
                                    <span className={"ml_20"}>{model.buyerName}</span>
                                </div>
                               {model.type=="disable"&&<>
                                    <div className={"lineGreyLight"}></div>
                                    <div className={"mt_8 black89"}>
                                        {model.contacts}
                                    </div>
                                    <div className={"black89"}>
                                        +{model.telCode}<span className={"ml_4"}>{model.phone}</span>
                                    </div>
                                </>}
                            </div>}
                            {/* 破损 | 买贵 商品 */}
                            {showDaDi&&<>
                                <div className={"lineGrey"} />
                                <div className={"mt_16 font_16 mb_4 black89"}>
                                    {this.__getServerLanguage("DingDan")}
                                    {/*<span className={"ml_4 mr_4"}>{mgPoInfoVO.poCode}</span>*/}
                                    <span className={"ml_4 cursor-p mr_4 color-blue"}><ModalOrderDetail id={mgPoInfoVO&&mgPoInfoVO.poId}>{mgPoInfoVO.poCode}</ModalOrderDetail></span>
                                    {this.getSkuType(model.type,model.statusMg)}
                                </div>
                            </>}
                            {/* 订单商品显示 */}
                            {showDaDi&&mgPoInfoVO&&<ClaimSkuWrap item={mgPoInfoVO} />}
                            {/* 破损 显示内容*/}
                            {model.type=="damaged"&&<>
                                {this.renderDesc(Lang({id:"ShouHouYuanYin",default:"售后原因"}))}
                                <div className={"btnSelectOn mt_4"}>{model.damageCodeName}</div>
                                {/* 售后产品数量 */}
                                {this.renderDesc(Lang({id:"ShouHouChanPinShuLiang",default:"售后产品数量"}))}
                                {/*  cdQuantity 申请的数量*/}
                                <div className={"btnSelectOn mt_4"}>{model.cdQuantity} {sUnit}</div>
                            </>}
                            {/* 破损 显示内容 END */}
                            {/* 买贵 显示内容*/}
                            {model.type=="disable"&&<>
                                {/* 供货渠道*/}
                                {this.renderDesc(Lang({id:"GongHuoQuDao",default:"供货渠道"}),model.channel)}
                                {/* 供货价格*/}
                                {this.renderDesc(Lang({id:"GongHuoJiaGe",default:"供货价格"})+"（" +mgPoInfoVO.currencySymbol+"）",symbolMoneyUtil(model.channelPrice,mgPoInfoVO.currencySymbol) +" / "+  sUnit)}
                            </>}
                            {/* 买贵 显示内容 END */}
                            <div className={"lineGrey"} />
                            {/* 晚到 显示内容*/}
                            {model.type=="arrive_late"&&<>
                                {this.renderDescLine(Lang({id:"PODingDan",default:"PO单号"}), <span className={"ml_4 cursor-p mr_4 color-blue"}><ModalOrderDetail id={mgPoInfoVO&&mgPoInfoVO.poId}>{mgPoInfoVO.poCode}</ModalOrderDetail></span>)}
                                {this.renderDescLine(Lang({id:"XiaDanShiJian",default:"下单时间"}),mgPoInfoVO.poCreateTime?dayjs(mgPoInfoVO.poCreateTime).format("YYYY-MM-DD"):"-")}
                                {this.renderDescLine(Lang({id:"ChengNuoDaoHuoShiJian",default:"承诺到货时间"}),model.preArrivalPortDate?dayjs(model.preArrivalPortDate).format("YYYY-MM-DD"):"-")}
                                {this.renderDescLine(Lang({id:"RuKuQueRenShiJian",default:"入库确认时间"}),model.intoWarehouseDate?dayjs(mgPoInfoVO.intoWarehouseDate).format("YYYY-MM-DD"):"-")}
                                {this.renderDescLine(Lang({id:"WanDaoTianShu",default:"晚到天数"}),model.auditArriveLateDay+" "+Lang({id:"TianS",default:"天"}))}
                                {this.renderDescLine(Lang({id:"PeiFuJinE",default:"赔付金额"}), symbolMoneyUtil(model.arriveLatePayAmount,mgPoInfoVO.currencySymbol))}
                                <div className={"mt_8 black45 mb_8"}>
                                    {Lang({id: 'DingDan', default: '订单'})}
                                    <span className={"ml_2"}>{symbolMoneyUtil(mgPoInfoVO.totalPrice,mgPoInfoVO.currencySymbol)}</span>
                                    <span className={"ml_2"}>*</span>
                                    <span className={"ml_2"}>{Lang({id: 'PeiFuBiLi', default: '赔付比例'})}</span>
                                    <span className={"ml_2"}>{model.ratio}</span>
                                    <span className={"ml_2"}>% *</span>
                                    <span className={"ml_2"}>{model.auditArriveLateDay}</span>
                                    <span className={"ml_2"}>{Lang({id:"TianS",default:"天"})}</span>
                                </div>
                                <div className={"lineGrey"} />
                            </>}
                            {/* 晚到 显示内容 END */}
                            {/* 历史 */}
                            <History model={model} />
                            {/* 破损 | 买贵 赔偿方式 */}
                            {showDaDi&&<>
                                <div className={"lineGrey"} />
                                {this.renderDesc(Lang({id:"PeiChangFangShi",default:"赔偿方式"}),)}
                                <div className={model.claimType=="10"?"color-err":""}>{this.getClaimType(model.claimType,__getDictList("sale_po_claim_demage_order_claim_type"))}</div>
                                {/* 现金模式下 有申请 文件 */}
                                {model.claimType=="20"&&model.applyFileUrl&&<a className={"upload-item-thumbnail-link"} href={model.applyFileUrl} target={"_blank"}>
                                    <div className={"upload-item-thumbnail"}>
                                        {renderFileType(model.applyFileUrl)}
                                    </div>
                                    <div className={"ellipsis mt_4 font_12 text-center"}>{model.applyFileUrl.substring(model.applyFileUrl.lastIndexOf("\/") + 1, model.applyFileUrl.length)}</div>
                                </a>}
                            </>}
                            {/* 审核 表格  statusMg 1:待处理 2:审核通过 3:已驳回 4:已撤销 5:已赔付 6:已失效 7:待汇款 8:已关闭 9:已发起*/}
                            {(showDaDi&&model.statusMg=="1")&&<>
                                {this.renderDesc(Lang({id:"PeiShenChuLi",default:"赔偿处理"}))}
                                {/* 买贵 的不大于0只能关闭 */}
                                {(model.type=="disable"&&(!model.quantity||model.quantity<=0))?<Popconfirm overlayClassName={"poAfterDetailPopconfirm"}
                                                                                        title={<div className={"black89 font_14"}>
                                                                                            <div className={"font_18 fw_700"}>{Lang({id:"TiShi",default:"提示"})}</div>
                                                                                            {Lang({id:"ShiFouYaoGuanBiSuoPeiShenQing",default:"是否要关闭赔偿申请"})}
                                                                                        </div>}
                                                                                        icon={null}
                                                                                        onConfirm={()=>this.handleCancel()}
                                                                                        okText={__getServerLanguage('QueDing')}
                                                                                        cancelText={__getServerLanguage('QuXiao')}>
                                   <span className={"color-err cursor-p"}
                                         // onClick={()=>this.handleCancel()}
                                         dangerouslySetInnerHTML={{
                                             __html: Lang({id:"DangQianShangPinYiQuanBuQuXiaoDengJi",
                                                 default:`当前商品已全部取消登记，请 <span class="color-blue">关闭赔偿</span>`})
                                         }}></span>
                                </Popconfirm>:<DetailHandleForm mgPoInfoVO={mgPoInfoVO}
                                                  handleCancel={()=>this.handleCancel()}
                                                  values={values}
                                                  claimDemageOrderId={claimDemageOrderId}
                                                  successBack={()=>this.props.successBack()}
                                                  model={model}/>}
                            </>}
                        </div>
                </div>
                </PageCommon>
        </Spin>)
    }
}
